import { Box } from '@mui/material';
import FadeTransition from '@mui/material/Fade';

export const Fade = ({ i, isIn, children }) => (
  <FadeTransition
    in={isIn}
    timeout={{ enter: 500, exit: 250 }}
    style={{ transitionDelay: `${i * 500}ms` }}
    key={i}
  >
    <Box>{children}</Box>
  </FadeTransition>
);
